import {Component, EventEmitter, Input, Output} from '@angular/core';
import {BadgeColorsEnum} from '../../interfaces/BadgeColorsEnum';

@Component({
  selector: 'app-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
})
export class BadgeComponent {
  @Input() color: BadgeColorsEnum;
  @Input() text: string;
  @Input() isOption: boolean;
  @Input() maxWidth = '110px';

  @Output() removeOption: EventEmitter<void> = new EventEmitter();

  BadgeColorsEnum = BadgeColorsEnum;

  constructor() {
  }
}
